(() => {
  // Check if the custom element 'subcategory-trigger' is already registered
  if (customElements.get('subcategory-trigger')) {
    return; // Exit if it's already defined
  }

  // Define the custom element 'SubcategoryTrigger' extending HTMLElement
  class SubcategoryTrigger extends HTMLElement {
    constructor() {
      super();
      // Add event listener setup here
      document.querySelectorAll('a[href^="?page=1#"].subcategory-scroll, a[href^="?page=2#"].subcategory-scroll').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
          e.preventDefault();

          const countElement = document.querySelector('.active-filters__count');
          const count = parseInt(countElement?.getAttribute('data-count'), 10);
          const urlParams = new URLSearchParams(window.location.search);

          const performScroll = () => {
            const stickyHeader = anchor.closest(".sticky-2");
            const targetId = this.getAttribute('href').split('#')[1];
            const targetSection = document.getElementById(targetId);

            if (targetSection) {
              const gappingSection = targetSection.previousElementSibling;

              if (gappingSection) {
                let scrollPosition;

                if(document.querySelector('.below_the_filter')){
                  if (window.innerWidth <= 768) {
                    scrollPosition = gappingSection.getBoundingClientRect().top + window.pageYOffset + (stickyHeader ? -50 : -150);
                  } else if (window.innerWidth >= 5000) {
                    scrollPosition = gappingSection.getBoundingClientRect().top + window.pageYOffset + (stickyHeader ? -50 : -450);
                  } else if (window.innerWidth >= 3000) {
                    scrollPosition = gappingSection.getBoundingClientRect().top + window.pageYOffset + (stickyHeader ? -50 : -450);
                  } else if (window.innerWidth >= 2560) {
                    scrollPosition = gappingSection.getBoundingClientRect().top + window.pageYOffset + (stickyHeader ? -120 : -350);
                  } else if (window.innerWidth >= 1920) {
                    scrollPosition = gappingSection.getBoundingClientRect().top + window.pageYOffset + (stickyHeader ? -120 : -250);
                  } else if (window.innerWidth >= 1600) {
                    scrollPosition = gappingSection.getBoundingClientRect().top + window.pageYOffset + (stickyHeader ? -50 : -280);
                  } else if (window.innerWidth >= 1440) {
                    scrollPosition = gappingSection.getBoundingClientRect().top + window.pageYOffset + (stickyHeader ? -120 : -250);
                  } else if (window.innerWidth >= 1400) {
                    scrollPosition = gappingSection.getBoundingClientRect().top + window.pageYOffset + (stickyHeader ? -120 : -270);
                  } else if (window.innerWidth >= 1280) {
                    scrollPosition = gappingSection.getBoundingClientRect().top + window.pageYOffset + (stickyHeader ? -120 : -100);
                  }
                } else if(document.querySelector('.banner_image_enable')){
                  if (window.innerWidth <= 768) {
                    scrollPosition = gappingSection.getBoundingClientRect().top + window.pageYOffset + (stickyHeader ? -30 : 70);
                  } else if (window.innerWidth >= 5000) {
                    scrollPosition = gappingSection.getBoundingClientRect().top + window.pageYOffset + (stickyHeader ? -50 : -450);
                  }if (window.innerWidth >= 3840) {
                    scrollPosition = gappingSection.getBoundingClientRect().top + window.pageYOffset + (stickyHeader ? -50 : -350);
                  } else if (window.innerWidth >= 3000) {
                    scrollPosition = gappingSection.getBoundingClientRect().top + window.pageYOffset + (stickyHeader ? -50 : -350);
                  } else if (window.innerWidth >= 2560) {
                    scrollPosition = gappingSection.getBoundingClientRect().top + window.pageYOffset + (stickyHeader ? -50 : -280);
                  } else if (window.innerWidth >= 1920) {
                    scrollPosition = gappingSection.getBoundingClientRect().top + window.pageYOffset + (stickyHeader ? -50 : -250);
                  } else if (window.innerWidth >= 1600) {
                    scrollPosition = gappingSection.getBoundingClientRect().top + window.pageYOffset + (stickyHeader ? -50 : -250);
                  } else if (window.innerWidth >= 1400) {
                    scrollPosition = gappingSection.getBoundingClientRect().top + window.pageYOffset + (stickyHeader ? -120 : -220);
                  } else if (window.innerWidth >= 1280) {
                    scrollPosition = gappingSection.getBoundingClientRect().top + window.pageYOffset + (stickyHeader ? -120 : -10);
                  }
                } else {
                  // Determine scroll position based on window width
                  if (window.innerWidth <= 768) {
                    scrollPosition = gappingSection.getBoundingClientRect().top + window.pageYOffset + (stickyHeader ? -30 : 70);
                  } else if (window.innerWidth >= 5000) {
                    scrollPosition = gappingSection.getBoundingClientRect().top + window.pageYOffset + (stickyHeader ? -50 : -450);
                  } else if (window.innerWidth >= 3000) {
                    scrollPosition = gappingSection.getBoundingClientRect().top + window.pageYOffset + (stickyHeader ? -50 : -350);
                  } else if (window.innerWidth >= 1920) {
                    scrollPosition = gappingSection.getBoundingClientRect().top + window.pageYOffset + (stickyHeader ? -120 : -5);
                  } else if (window.innerWidth >= 1600) {
                    scrollPosition = gappingSection.getBoundingClientRect().top + window.pageYOffset + (stickyHeader ? -50 : -250);
                  } else if (window.innerWidth >= 1440) {
                    scrollPosition = gappingSection.getBoundingClientRect().top + window.pageYOffset + (stickyHeader ? -140 : -50);
                  } else if (window.innerWidth >= 1280) {
                    scrollPosition = gappingSection.getBoundingClientRect().top + window.pageYOffset + (stickyHeader ? -120 : -10);
                  }
                }


                // Scroll to the calculated position with smooth behavior
                window.scrollTo({ top: scrollPosition, behavior: 'smooth' });
              }
            }
          };

          if (count > 0 || urlParams.has('sort_by')) {
            setTimeout(() => {
              performScroll();
            }, 4000);
          } else {
            performScroll();
          }
        });
      });
    }
  }

  // Define 'subcategory-trigger' custom element
  customElements.define('subcategory-trigger', SubcategoryTrigger);
})();
